import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import LoadThemeComponent from '../../../base/LoadThemeComponent';
import { isDefault, isPlayport, isPremierDubai, isTemplateDelta } from '../../../utils/template';
import CasinoDropdownMenu from '../../casino/user/user-panel/CasinoDropdownMenu';
import AccountIcon from '../../default/AccountIcon';
import { setDropdownState } from '../../default/setDropdownState';
import NotificationBell from '../../notifications/NotificationBell.lazy';

import DropdownMenu from './DropdownMenu';
import {useUserBalance} from "../../../Store/Slicers/UserSlice";

const notificationsEnabled = process.env.MIX_NOTIFICATIONS_ENABLED === 'true';

function AuthorizedPanel({ user, links }) {
    const { t } = useTranslation();
    const {balance} = useUserBalance();
    // API now returns amount as integers, so we have to divide to prevent BC
    const legacyBalanceAmount = user ? (balance.amount / 100) : '';
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const toggleDropdown = () => {
        setDropdownState(!isDropdownOpen, setIsDropdownOpen);
    };

    const handleCloseDropdown = () => {
        setDropdownState(false, setIsDropdownOpen);
    };

    function getBalance() {
        return (
            <div key="balance" className="d-xl-flex d-none align-items-center btn-account btn-left">
                <span
                    className="balance"
                    id="user-balance"
                    data-balance={!window.IS_USER_IN_PLAY ? legacyBalanceAmount : ''}
                >
                    {!window.IS_USER_IN_PLAY ? balance.formatted : `(${t('myAccount.inPlay')})`}
                </span>
            </div>
        );
    }

    const baseView = () => (
        <div key="dropdown" className="dropdown d-xl-inline-block d-none account-dropdown-menu">
            <span className="d-flex align-items-center btn btn-transparent btn-account btn-right">
                {isTemplateDelta() ? (
                    <img src="/images/base/nav-icon-user.png" alt="Account" width="32" />
                ) : (
                    <i className="fas fa-cog" />
                )}
            </span>
            {window.IS_CASINO ? (
                <CasinoDropdownMenu links={links} user={user} />
            ) : (
                <DropdownMenu links={links} user={user} />
            )}
        </div>
    );

    const defaultView = () => (
        <div key="dropdown" className="dropdown d-inline account-dropdown-menu">
            <span className="d-flex align-items-center btn btn-transparent btn-account btn-right">
                <AccountIcon
                    style={{
                        width: 'auto',
                        height: '20px',
                        fill: 'white',
                    }}
                    onClick={toggleDropdown}
                />
            </span>
            {window.IS_CASINO ? (
                <CasinoDropdownMenu links={links} user={user} />
            ) : (
                isDropdownOpen && <DropdownMenu links={links} user={user} onClose={handleCloseDropdown} />
            )}
        </div>
    );

    function getDropdown() {
        return <LoadThemeComponent defaultView={defaultView} baseView={baseView} />;
    }

    const renderDefaultContent = () => (
        <>
            {notificationsEnabled && <NotificationBell key="notification" />}
            {getDropdown()}
        </>
    );

    const renderBaseContent = () => (
        <>
            {getBalance()}
            {isPlayport() && notificationsEnabled && <NotificationBell key="notification" />}
            {getDropdown()}
            <div key="deposit">
                <a className="btn btn-sm btn-header-deposit d-xl-inline-block d-none" href={links.deposit}>
                    {isPremierDubai() ? t('userPanel.makeContribution') : t('userPanel.makeDeposit')}
                </a>
            </div>
            {!isPlayport() && notificationsEnabled && <NotificationBell key="notification" />}
        </>
    );
    return <>{isDefault() ? renderDefaultContent() : renderBaseContent()}</>;
}

export default AuthorizedPanel;
